export function LoadingBar({ visible }: { visible: boolean }) {
  if (!visible) return null;

  return (
    <div className="relative">
      <div className="bg-primary-100 absolute top-0 right-0 left-0 z-10 h-1 overflow-hidden">
        <div className="animate-loading-bar bg-primary-500 h-full w-1/3 rounded-full" />
      </div>
    </div>
  );
}
